var InAppMessage, template,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

template = require('../vVERSION.html.mustache');

module.exports = InAppMessage = (function() {
  return {
    init: function() {
      if (!(this.$el = $('#ls-in-app-messages')).length) {
        return;
      }
      return this.fetch();
    },
    fetch: function() {
      var c, categoryId, data, ref, ref1, ref2, ref3;
      c = (ref = Cookie.get('c')) != null ? ref.replace(/"/g, '') : void 0;
      categoryId = document.head.getAttribute('data-categoryid');
      data = {
        division_id: typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.division) != null ? ref1.id : void 0 : void 0,
        page: 1,
        per_page: 1,
        consumer_id: c ? c : void 0,
        app_name: document.head.getAttribute('data-app'),
        locale: document.head.getAttribute('data-locale'),
        category_id: categoryId ? categoryId : void 0
      };
      if ((ref2 = Groupon.PageFlags) != null ? ref2.isTouchRequest : void 0) {
        data.device_id = 'ITIER-DEVICE_ID';
      }
      if (Groupon.LS.experiments['LS-2120-IAM-Viewport-Param']) {
        data.viewport = $(window).width();
      }
      return $.ajax({
        type: "GET",
        url: ((ref3 = Groupon.endpoints) != null ? ref3.in_app_messages : void 0) || '/in_app_messages',
        data: data,
        success: (function(_this) {
          return function(res) {
            var blocked, nonDismissable, ref4, ref5;
            if ((res != null ? res.id : void 0) != null) {
              blocked = _this.getBlockedMessageIds();
              _this.id = res.id.toString();
              if (ref4 = _this.id, indexOf.call(blocked, ref4) < 0) {
                nonDismissable = ((ref5 = Groupon.LS.experiments) != null ? ref5['LS-2609-non-dismissible-IAM'] : void 0) != null;
                _this.$el.html(template.render({
                  res: res,
                  nonDismissable: nonDismissable
                }));
                if (!nonDismissable) {
                  return _this.attachDismissListener();
                }
              }
            } else {
              return Groupon.Utils.trackEvent('iam-no-message-id');
            }
          };
        })(this),
        error: function() {
          return Groupon.Utils.trackEvent('iam-call-failed');
        }
      });
    },
    getBlockedMessageIds: function() {
      var value;
      value = Cookie.get('msg_hide');
      if (value) {
        return value.split(",");
      } else {
        return [];
      }
    },
    setBlockedMessageIds: function(blocked) {
      var value;
      if (blocked.length > 20) {
        blocked.shift();
      }
      value = blocked.join(",");
      return Cookie.set('msg_hide', value);
    },
    blockMessage: function(message_id) {
      var blocked;
      blocked = this.getBlockedMessageIds();
      if (indexOf.call(blocked, message_id) < 0) {
        blocked.push(message_id);
        return this.setBlockedMessageIds(blocked);
      }
    },
    attachDismissListener: function() {
      var ref, ref1;
      return this.$el.find('.hide-link').attr('aria-label', ((ref = Groupon.LS.translations) != null ? (ref1 = ref.ax) != null ? ref1.close : void 0 : void 0) || 'close').one('click', (function(_this) {
        return function(event) {
          event.preventDefault();
          _this.$el.addClass('hide');
          if (_this.id > 0) {
            return _this.blockMessage(_this.id);
          }
        };
      })(this));
    }
  };
})();

//# sourceMappingURL=data:application/json;base64,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
